var InAppMessage, template,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

template = require('../vVERSION.html.mustache');

module.exports = InAppMessage = (function() {
  return {
    init: function() {
      if (!(this.$el = $('#ls-in-app-messages')).length) {
        return;
      }
      return this.fetch();
    },
    fetch: function() {
      var c, categoryId, data, ref, ref1, ref2, ref3;
      c = (ref = Cookie.get('c')) != null ? ref.replace(/"/g, '') : void 0;
      categoryId = document.head.getAttribute('data-categoryid');
      data = {
        division_id: typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.division) != null ? ref1.id : void 0 : void 0,
        page: 1,
        per_page: 1,
        consumer_id: c ? c : void 0,
        app_name: document.head.getAttribute('data-app'),
        locale: document.head.getAttribute('data-locale'),
        category_id: categoryId ? categoryId : void 0
      };
      if ((ref2 = Groupon.PageFlags) != null ? ref2.isTouchRequest : void 0) {
        data.device_id = 'ITIER-DEVICE_ID';
      }
      if (Groupon.LS.experiments['LS-2120-IAM-Viewport-Param']) {
        data.viewport = $(window).width();
      }
      return $.ajax({
        type: "GET",
        url: ((ref3 = Groupon.endpoints) != null ? ref3.in_app_messages : void 0) || '/in_app_messages',
        data: data,
        success: (function(_this) {
          return function(res) {
            var blocked, nonDismissable, ref4, ref5;
            if ((res != null ? res.id : void 0) != null) {
              blocked = _this.getBlockedMessageIds();
              _this.id = res.id.toString();
              if (ref4 = _this.id, indexOf.call(blocked, ref4) < 0) {
                nonDismissable = ((ref5 = Groupon.LS.experiments) != null ? ref5['LS-2609-non-dismissible-IAM'] : void 0) != null;
                _this.$el.html(template.render({
                  res: res,
                  nonDismissable: nonDismissable
                }));
                if (!nonDismissable) {
                  return _this.attachDismissListener();
                }
              }
            } else {
              return Groupon.Utils.trackEvent('iam-no-message-id');
            }
          };
        })(this),
        error: function() {
          return Groupon.Utils.trackEvent('iam-call-failed');
        }
      });
    },
    getBlockedMessageIds: function() {
      var value;
      value = Cookie.get('msg_hide');
      if (value) {
        return value.split(",");
      } else {
        return [];
      }
    },
    setBlockedMessageIds: function(blocked) {
      var value;
      if (blocked.length > 20) {
        blocked.shift();
      }
      value = blocked.join(",");
      return Cookie.set('msg_hide', value);
    },
    blockMessage: function(message_id) {
      var blocked;
      blocked = this.getBlockedMessageIds();
      if (indexOf.call(blocked, message_id) < 0) {
        blocked.push(message_id);
        return this.setBlockedMessageIds(blocked);
      }
    },
    attachDismissListener: function() {
      var ref, ref1;
      return this.$el.find('.hide-link').attr('aria-label', ((ref = Groupon.LS.translations) != null ? (ref1 = ref.ax) != null ? ref1.close : void 0 : void 0) || 'close').one('click', (function(_this) {
        return function(event) {
          event.preventDefault();
          _this.$el.addClass('hide');
          if (_this.id > 0) {
            return _this.blockMessage(_this.id);
          }
        };
      })(this));
    }
  };
})();

//# sourceMappingURL=data:application/json;base64,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
